var InAppMessage, template,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

template = require('../vVERSION.html.mustache');

module.exports = InAppMessage = (function() {
  return {
    init: function() {
      if (!(this.$el = $('#ls-in-app-messages')).length) {
        return;
      }
      return this.fetch();
    },
    fetch: function() {
      var c, categoryId, data, ref, ref1, ref2, ref3;
      c = (ref = Cookie.get('c')) != null ? ref.replace(/"/g, '') : void 0;
      categoryId = document.head.getAttribute('data-categoryid');
      data = {
        division_id: typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.division) != null ? ref1.id : void 0 : void 0,
        page: 1,
        per_page: 1,
        consumer_id: c ? c : void 0,
        app_name: document.head.getAttribute('data-app'),
        locale: document.head.getAttribute('data-locale'),
        category_id: categoryId ? categoryId : void 0
      };
      if ((ref2 = Groupon.PageFlags) != null ? ref2.isTouchRequest : void 0) {
        data.device_id = 'ITIER-DEVICE_ID';
      }
      if (Groupon.LS.experiments['LS-2120-IAM-Viewport-Param']) {
        data.viewport = $(window).width();
      }
      return $.ajax({
        type: "GET",
        url: ((ref3 = Groupon.endpoints) != null ? ref3.in_app_messages : void 0) || '/in_app_messages',
        data: data,
        success: (function(_this) {
          return function(res) {
            var blocked, nonDismissable, ref4, ref5;
            if ((res != null ? res.id : void 0) != null) {
              blocked = _this.getBlockedMessageIds();
              _this.id = res.id.toString();
              if (ref4 = _this.id, indexOf.call(blocked, ref4) < 0) {
                nonDismissable = ((ref5 = Groupon.LS.experiments) != null ? ref5['LS-2609-non-dismissible-IAM'] : void 0) != null;
                _this.$el.html(template.render({
                  res: res,
                  nonDismissable: nonDismissable
                }));
                if (!nonDismissable) {
                  return _this.attachDismissListener();
                }
              }
            } else {
              return Groupon.Utils.trackEvent('iam-no-message-id');
            }
          };
        })(this),
        error: function() {
          return Groupon.Utils.trackEvent('iam-call-failed');
        }
      });
    },
    getBlockedMessageIds: function() {
      var value;
      value = Cookie.get('msg_hide');
      if (value) {
        return value.split(",");
      } else {
        return [];
      }
    },
    setBlockedMessageIds: function(blocked) {
      var value;
      if (blocked.length > 20) {
        blocked.shift();
      }
      value = blocked.join(",");
      return Cookie.set('msg_hide', value);
    },
    blockMessage: function(message_id) {
      var blocked;
      blocked = this.getBlockedMessageIds();
      if (indexOf.call(blocked, message_id) < 0) {
        blocked.push(message_id);
        return this.setBlockedMessageIds(blocked);
      }
    },
    attachDismissListener: function() {
      var ref, ref1;
      return this.$el.find('.hide-link').attr('aria-label', ((ref = Groupon.LS.translations) != null ? (ref1 = ref.ax) != null ? ref1.close : void 0 : void 0) || 'close').one('click', (function(_this) {
        return function(event) {
          event.preventDefault();
          _this.$el.addClass('hide');
          if (_this.id > 0) {
            return _this.blockMessage(_this.id);
          }
        };
      })(this));
    }
  };
})();

//# sourceMappingURL=data:application/json;base64,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
